<template>
  <div>
    <navbarBox />
    <showpartnerscomponents />
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
import showpartnerscomponents from "@/components/showPartnersComponents.vue";
export default {
  components: { showpartnerscomponents, navbarBox },
};
</script>
